(function() {
    if (window.__cItemsAssetsInitialized) return;
    window.__cItemsAssetsInitialized = true;

    const mobileMediaQuery = window.matchMedia('(max-width: 750px)');
    const registry = window.__cItemsSectionRegistry || (window.__cItemsSectionRegistry = {});

    const destroySlider = function(sectionId) {
        if (registry[sectionId] && registry[sectionId].swiper) {
            registry[sectionId].swiper.destroy(true, true);
        }

        delete registry[sectionId];
    };

    const syncSliderState = function(sectionRoot) {
        if (!sectionRoot || typeof Swiper === 'undefined') {
            return;
        }

        const sectionId = sectionRoot.dataset.sectionId;
        if (!sectionId) return;

        const swiperElement = sectionRoot.querySelector(`[data-swiper-id="c-items-slider-${sectionId}"]`);

        if (!swiperElement) {
            return;
        }

        if (!mobileMediaQuery.matches) {
            destroySlider(sectionId);
            return;
        }

        if (registry[sectionId] && registry[sectionId].swiper) {
            registry[sectionId].swiper.update();
            return;
        }

        const prevButton = sectionRoot.querySelector(`[data-prev-${sectionId}]`);
        const nextButton = sectionRoot.querySelector(`[data-next-${sectionId}]`);

        registry[sectionId] = {
            swiper: new Swiper(swiperElement, {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 16,
                loop: false,
                navigation: {
                    prevEl: prevButton,
                    nextEl: nextButton
                },
                watchOverflow: true
            })
        };
    };

    const findSectionRoots = function(container) {
        const roots = [];

        if (container instanceof Element && container.matches('[data-c-items-section]')) {
            roots.push(container);
        }

        if (container.querySelectorAll) {
            roots.push(...container.querySelectorAll('[data-c-items-section]'));
        }

        return roots;
    };

    const initializeSections = function(container, reset) {
        findSectionRoots(container).forEach(function(sectionRoot) {
            const sectionId = sectionRoot.dataset.sectionId;

            if (reset && sectionId) {
                destroySlider(sectionId);
            }

            syncSliderState(sectionRoot);
        });
    };

    initializeSections(document, false);

    const handleMediaChange = function() {
        initializeSections(document, false);
    };

    const handleSectionLoad = function(event) {
        initializeSections(event.target, true);
    };

    const handleSectionUnload = function(event) {
        findSectionRoots(event.target).forEach(function(sectionRoot) {
            const sectionId = sectionRoot.dataset.sectionId;
            if (sectionId) destroySlider(sectionId);
        });
    };

    mobileMediaQuery.addEventListener('change', handleMediaChange);
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

})();
